import { z } from 'zod/v4';
import type { TracingEvent } from '../../core/use-cases/types.js';

export const ATTACH_ORDER_DOCUMENTS_MAX = 20;

export const AttachOrderDocumentsInputSchema = z.object({
  orderId: z.string().min(1),
  orderLineId: z.string().min(1).optional(),
  attachments: z
    .array(
      z.object({
        fileId: z.string().min(1),
        type: z.string().min(1),
        name: z.string().min(1).optional(),
        reference: z.string().optional(),
        description: z.string().optional(),
      }),
    )
    .min(1)
    .max(ATTACH_ORDER_DOCUMENTS_MAX)
    .refine(
      items => new Set(items.map(a => a.fileId)).size === items.length,
      'Duplicate fileId in attachments',
    ),
});

export type AttachOrderDocumentsInput = z.infer<
  typeof AttachOrderDocumentsInputSchema
>;

export const AttachOrderDocumentsResponseSchema = z.object({
  orderId: z.string(),
  documentIds: z.array(z.string()),
});

export type AttachOrderDocumentsResponse = z.infer<
  typeof AttachOrderDocumentsResponseSchema
>;

export type AttachOrderDocumentsResult = AttachOrderDocumentsResponse & {
  tracingEvents: TracingEvent[];
};
